import { useReportItemsView } from '@views/pages/ReportItemsView/hooks';

import { PreviewWrapper } from '@views/pages/Reporting/Reports/Report/components/Preview/PreviewWrapper.tsx';

export const ReportItemsView = () => {
  const { report_id } = useReportItemsView();

  return <>{report_id && <PreviewWrapper />}</>;
};
